import Nanobus from 'nanobus'

// Create and export a global event bus instance
const bus = new Nanobus()

export { bus } 